module.exports = __webpack_public_path__ + "img/tournament-icon-white.175ef8db.svg";